import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { QuotesDataProvider } from '@services/quote/quotes-data-service/quotes.data.service';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'modal-make-invoice',
	template: require('./modal-make-invoice.html'),
	styles: [require('./modal-make-invoice.scss')]
})
export class ModalMakeInvoiceComponent {
	@Input('jobId') jobId: number;
	@Input('quoteId') quoteId: number;
	@Input('url') url = '';
	@Output('updateBtnActions')
	updateBtnActions: EventEmitter<number> = new EventEmitter<number>();
	disableButtons = false;

	constructor(
		private quotesDataService: QuotesDataProvider,
		private messageService: MessageService
	) {}

	generateInvoice(): void {
		this.disableButtons = true;
		if (this.url) {
			localStorage.setItem('GENERATE_INVOICE', 'true');
			location.href = this.url;
		} else {
			this.quotesDataService
				.generateInvoiceFromQuote(this.jobId, this.quoteId)
				.pipe(finalize((): boolean => (this.disableButtons = false)))
				.subscribe(
					(data): void => this.successGenerateInvoice(data),
					(error): void => this.messageService.handleError(error)
				);
		}
	}

	successGenerateInvoice(res) {
		this.messageService.showToaster('s_0', 'editQuote');
		$('#generateInvoiceModal').modal('hide');
		this.updateBtnActions.emit(res.data.id);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/quote/modals/modal-make-invoice/modal-make-invoice.ts